export default {
  placeholder: 'Select a tag',
  createTag: 'Create event tag',
};
